import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { COOKIE_PREFIX, DEFAULT_COOKIE_DOMAIN } from './auth.const';
import { computed } from '@angular/core';
import { environment } from '../../../environments/environment';
import { User } from './auth.model';

interface AuthState {
  cookiePrefix: string;
  user: User | null;
  cookieDomain: string;
  isAiTimeLimitExceeded: boolean;
}

const initialState: AuthState = {
  cookiePrefix: COOKIE_PREFIX,
  user: null,
  cookieDomain: `.${environment.aitarget_domain || DEFAULT_COOKIE_DOMAIN}`,
  isAiTimeLimitExceeded: false
};

export const AuthStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withComputed(({ cookiePrefix, user, isAiTimeLimitExceeded }) => ({
    cookies: computed(() => ({
      main: environment.production
        ? `${cookiePrefix()}_PROD_share_token`
        : `${cookiePrefix()}_STAGE_share_token`,
      client: environment.production
        ? `${cookiePrefix()}_PROD_share_client_id`
        : `${cookiePrefix()}_STAGE_share_client_id`,
      refresh: environment.production
        ? `${cookiePrefix()}_PROD_share_refresh_token`
        : `${cookiePrefix()}_STAGE_share_refresh_token`,
      switchedUser: environment.production
        ? `${cookiePrefix()}_PROD_share_switch_user`
        : `${cookiePrefix()}_STAGE_share_switch_user`
    })),
    isAiShown: computed(() => {
      const u = user();

      if (!u) {
        return false;
      }

      return u.approved || !isAiTimeLimitExceeded();
    })
  })),
  withMethods((store) => ({
    updateUser: (user: User | null) => {
      patchState(store, { user });
    },
    updateIsAiTimeLimitExceeded: (isAiTimeLimitExceeded: boolean) => {
      patchState(store, { isAiTimeLimitExceeded });
    }
  }))
);
